/* istanbul ignore file */

import React from 'react';
import { StyleSheetManager } from 'styled-components';
import { RIBBONS_BASE_STYLES_SCOPE_CLASS } from "../../styles/baseStylesGenerators";
var RULESET = 'rule';

// This is a styled-components stylis plugin / stylis middleware to replace the previous
// `stylis-plugin-extra-scope` package which doesn't work with styled-components v6.
// see: https://github.com/thysultan/stylis?tab=readme-ov-file#middleware
var extraRibbonsScopePlugin = function extraRibbonsScopePlugin(element) {
  // we only want "rule"-type definitions
  if (element.type === RULESET) {
    // add our chosen prefix to any declared classes
    element.props = element.props.map(function (className) {
      return ".".concat(RIBBONS_BASE_STYLES_SCOPE_CLASS, " ").concat(className);
    });
  }
};
Object.defineProperty(extraRibbonsScopePlugin, 'name', {
  value: 'extraRibbonsScopePlugin'
});
export var ScopedStylesProvider = function ScopedStylesProvider(_ref) {
  var children = _ref.children,
    useScopedStyles = _ref.useScopedStyles;
  var stylisPlugins = useScopedStyles ? [extraRibbonsScopePlugin] : [];
  return /*#__PURE__*/React.createElement(StyleSheetManager, {
    stylisPlugins: stylisPlugins
  }, children);
};